import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || '/';
console.log("Base URL:", baseURL);

// Tworzymy instancję axios
const api = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Pomocnicza funkcja sprawdzająca, czy token jest już nieważny.
 * @param {string} token - JWT pobrany np. z localStorage.
 * @returns {boolean} true, jeśli token wygasł lub jest nieprawidłowy
 */
function isTokenExpired(token) {
    try {
        const payloadBase64 = token.split('.')[1];
        const payload = JSON.parse(atob(payloadBase64)); // dekodujemy bazę 64
        const now = Math.floor(Date.now() / 1000);

        // jeśli exp <= obecny czas (sekundy), token uznajemy za wygasły
        return payload.exp <= now;
    } catch (err) {
        // jeśli wystąpił błąd przy dekodowaniu, traktujemy token jako nieważny
        console.error('Błąd przy sprawdzaniu ważności tokena:', err);
        return true;
    }
}

// Lista endpointów, dla których nie sprawdzamy tokena
const excludedEndpoints = ['/login', '/register', '/public'];

// --- Request Interceptor ---
// Wykonuje się przed każdym zapytaniem do API
api.interceptors.request.use(
    (config) => {
        const { url } = config;

        // Sprawdzamy, czy aktualny endpoint jest wykluczony
        const isExcluded = excludedEndpoints.some((endpoint) => url.startsWith(endpoint));

        if (!isExcluded) {
            const token = localStorage.getItem('token');
            if (token) {
                // Sprawdzamy ważność tokena
                if (isTokenExpired(token)) {
                    console.log('Token wygasł — wyloguj użytkownika lub wyświetl komunikat.');
                    alert('Twoja sesja wygasła. Zaloguj się ponownie.');

                    // Opcjonalne wyczyszczenie tokena
                    localStorage.removeItem('token');

                    window.location.href = '/login';

                    // Anulujemy zapytanie
                    throw new axios.Cancel('Anulowano zapytanie — token wygasł.');
                }

                // Dodajemy token do nagłówków
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// --- Response Interceptor ---
// Wykonuje się po otrzymaniu odpowiedzi z API
api.interceptors.response.use(
    (response) => {
        // Jeśli serwer zwrócił nowy token w nagłówku `X-New-Token`, zapiszmy go
        const newToken = response.headers['x-new-token'];
        if (newToken) {
            localStorage.setItem('token', newToken);
        }
        return response;
    },
    (error) => {
        // Możliwa obsługa błędów 401, 403 itp.
        if (error.response && error.response.status === 401) {
            console.error('Błąd 401 - nieautoryzowany. Możliwe, że token wygasł lub jest nieprawidłowy.');

            // Opcjonalnie wylogowanie użytkownika
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
